import { render, staticRenderFns } from "./assure-medicaments.html?vue&type=template&id=54d778aa&scoped=true&external"
import script from "./assure-medicaments.js?vue&type=script&lang=js&external"
export * from "./assure-medicaments.js?vue&type=script&lang=js&external"
import style0 from "./assure-medicaments.scss?vue&type=style&index=0&id=54d778aa&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d778aa",
  null
  
)

export default component.exports